import React from "react";
import { Search, Wrench, Settings, FlaskConical, Truck } from "lucide-react";
import { processSteps } from "../mock";

const iconMap = { Search, Wrench, Settings, FlaskConical, Truck };

export default function ProcessSection() {
  return (
    <section className="bg-neutral-900 text-white bg-dotted-dark py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[11px] tracking-[0.3em] text-orange-500 font-semibold uppercase">How We Work</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 uppercase">Our Manufacturing Process</h2>
          <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-4" />
        </div>
        <div className="relative grid grid-cols-2 md:grid-cols-5 gap-y-12 gap-x-4">
          <div className="process-line hidden md:block" />
          {processSteps.map((p, i) => {
            const Icon = iconMap[p.icon];
            return (
              <div key={i} className="relative z-10 flex flex-col items-center text-center px-2">
                <div className="relative">
                  <div className="w-20 h-20 rounded-full bg-neutral-900 ring-2 ring-orange-500 flex items-center justify-center text-orange-500">
                    <Icon size={28} />
                  </div>
                  <span className="absolute -top-2 left-1/2 -translate-x-1/2 bg-orange-500 text-white text-[10px] font-bold tracking-widest px-2 py-0.5 rounded-full">
                    {p.step}
                  </span>
                </div>
                <h4 className="font-display text-lg mt-4 uppercase">{p.title}</h4>
                <p className="text-sm text-neutral-400 mt-1 max-w-[180px]">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
